import { unstable_ClassNameGenerator as ClassNameGenerator } from "@mui/material/className";

/**
 * Class-name isolation for the PM5 v4/v5+ coexistence era.
 *
 * MUI v4 (JSS) and MUI v9 (emotion) both emit *static* `Mui*` class names —
 * `.MuiButton-root`, `.MuiInputBase-input`, … — for the same component names.
 * With both libraries in the bundle those collide, and whichever stylesheet
 * lands last silently wins. Renaming the v5+ side keeps the two engines
 * disjoint (official coexistence guidance; PM5 D1 / risk 1).
 *
 * Prefix: **`FfV5`** → `.FfV5Button-root`, `.FfV5InputBase-input`, …
 * (`Ff` = FarmFlix; `V5` = "the v5-line theme", the name the migration note
 * uses — the installed major is v9 but the rig is the v5+ side of the bridge.)
 *
 * NOT renamed — and deliberately so: the *global state* classes
 * (`Mui-active`, `Mui-error`, `Mui-focused`, `Mui-disabled`, …). MUI's
 * `generateUtilityClass` hard-codes the `Mui` prefix for those and the
 * generator never sees them. They are harmless: neither theme declares a
 * bare `.Mui-*` rule — every use is compounded with a component class
 * (`.FfV5OutlinedInput-root.Mui-error` vs v4's JSS-hashed root) — so the two
 * engines still cannot reach each other's elements.
 *
 * **Import-order matters.** Several `@mui/material` modules call
 * `generateUtilityClasses(...)` at module-evaluation time, so the prefix must
 * be configured before any of them is imported. This module therefore pulls in
 * only `@mui/material/className` (a re-export of `@mui/utils/ClassNameGenerator`,
 * no components), and is imported first by `src/index.js` and again at the top
 * of `src/theme/themeV5.ts` so it cannot be bypassed.
 */
export const V5_CLASS_PREFIX = "FfV5";

ClassNameGenerator.configure((componentName) =>
  componentName.startsWith("Mui")
    ? `${V5_CLASS_PREFIX}${componentName.slice("Mui".length)}`
    : `${V5_CLASS_PREFIX}${componentName}`,
);
